import * as React from 'react';
import Container from '@mui/material/Container';
import ActualityCard from './ActualityCard';
import { useState, useEffect } from "react";
import axios from '../../axios';
import {Box, IconButton} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {useActualities} from "./hooks/useActuality";
import {withActualitiesContext} from "./context/actualityContext";
import PostActuality from "../dashboard/PostActuality";
import {withUserCommunitiesContext} from "../community/context/userCommunitiesContext";
import {useRole} from "../userInfo/hooks/useRole";

const ActualityList = ({ token, id, setDisableActuality, actualitiesResult }) => {
  const [showMoveUpButton, setShowMoveUpButton] = useState(false);
  const [showMoveDownButton, setShowMoveDownButton] = useState(true);
  const [anchor, setAnchor] = useState(0);
  const {actualities, updateActualities} = useActualities(actualitiesResult);
  const {canPublish} = useRole();
  console.log(actualities);

  const header = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };



  const moveUp = () => {
    const tempPosition = anchor - 1;
    const tempAnchor = 'anchor'+tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - 200,
        behavior: "smooth",
      });
      setAnchor(anchor - 1);
    }
    const nextPosition = tempPosition - 1;
    if (document.getElementById('anchor'+nextPosition) == null) {
      setShowMoveDownButton(true);
      setShowMoveUpButton(false);
    } else {
      setShowMoveUpButton(true);
      setShowMoveDownButton(true);
    }
  };

  const moveDown = () => {
    const tempPosition = anchor + 1;
    const tempAnchor = 'anchor'+tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - 200,
        behavior: "smooth",
      });
      setAnchor(anchor + 1);
    }
    const nextPosition = tempPosition + 1;
    if (document.getElementById('anchor'+nextPosition) == null) {
      setShowMoveUpButton(true);
      setShowMoveDownButton(false);
    } else {
      setShowMoveDownButton(true);
      setShowMoveUpButton(true);
    }

  };

  return (
    <Box>
      {canPublish && <PostActuality updateActualities={updateActualities}/>}
      <Box style={{marginBottom : 10}}></Box>
      {
          actualities && actualities.length > 0 && actualities.toReversed().map((actuality,index) => (
            <div id={'anchor'+index}>
              <ActualityCard actuality={actuality} header={header} token={token}/>
              <br/>
            </div>

        ))
      }
      {
        showMoveUpButton ?
            <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
              <IconButton
                  className={'btn-gradient'}
                  sx={{
                    color: '#FFFFFF',
                    borderRadius: 0,
                    borderTopLeftRadius: '10%',
                    borderBottomLeftRadius: '10%'
                  }}
                  onClick={moveUp}
              >
                <ArrowUpwardIcon role="img" aria-label={"Remonter au bloc précedent"}/>
              </IconButton>
            </Box> : <div></div>
      }
      {
        showMoveDownButton ?
            <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
              <IconButton
                  className={'btn-gradient'}
                  sx={{
                    color: '#FFFFFF',
                    borderRadius: 0,
                    borderTopLeftRadius: '10%',
                    borderBottomLeftRadius: '10%'
                  }}
                  onClick={moveDown}
              >
                <ArrowDownwardIcon role="img" aria-label={"Descendre au bloc suivant"}/>
              </IconButton>
            </Box>: <div></div>
      }
    </Box>
  )
}

export default withUserCommunitiesContext(withActualitiesContext(ActualityList));
